// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/inbox.js';

import { paths } from '../generated/inbox';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('inbox', Original, paths);
